import { atom } from 'jotai';

type ActivityListSelections = Record<string, number>;

export const activityListSelectionsAtom = atom<ActivityListSelections>({});

export const setActivityListSelectionAtom = atom(
    null,
    (get, set, { contextKey, activityId }: { contextKey: string; activityId: number }) => {
        set(activityListSelectionsAtom, {
            ...get(activityListSelectionsAtom),
            [contextKey]: activityId,
        });
    },
);
